import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import { AlertDialogTitle as AlertDialogTitleBase } from "./base/AlertDialogBase"

export type AlertDialogTitleProps = ComponentProps<typeof AlertDialogTitleBase>

function AlertDialogTitle(props: AlertDialogTitleProps) {
  const { className, ...alertDialogTitleBaseProps } = props

  return (
    <AlertDialogTitleBase
      className={cn("ui-alert-dialog-title", className)}
      {...alertDialogTitleBaseProps}
    />
  )
}

export default AlertDialogTitle
